import React, { useEffect, useState, useContext, useCallback } from 'react';
import Sidebar from './Sidebar'
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import ThemeContext from '../theme-context'
import {useSelector} from 'react-redux'
import PokeSprites from './PokeSprites'

const style = {
    textAlign: "center",
    marginTop: 30
}

export default function PokeGuide(props) {
const {theme} = useContext(ThemeContext);
const numberArr = Array.from(Array(898).keys());

const numberMap = numberArr.map(entry => {
    return (
        <button className="poke-button" onClick={() => props.getPokemon(entry+1)} style={{padding:2,fontSize:8}}>{entry+1}</button>
    )
})
    return (
        <>
            <Container maxWidth="lg">
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <h1 style={{textAlign: 'center'}}>Choose your Pokémon!</h1>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" color={theme} onClick={props.handleClick} style={{marginRight: "auto"}}>Choose Random Pokémon</Button>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                 <h4>Choose a Pokémon by number</h4>
                    <div className="number-wrap">
                    {numberMap}
                    </div>
                </Grid>
                <Grid container spacing={6}>
                   <Grid item xs={12} style={style}>
                       {(props.pokemon && props.pokemon.id) &&
                        <PokeSprites pokemon={props.pokemon} />
                        }
                   </Grid>
                </Grid>
            </Container>
        </>
    )
}